<div class="grid-toolbar">
  <div class="grid-title">
    <h5>
      Ticketing Emails
      <span
        kendoTooltip
        tooltipClass="custom-tooltip"
        title="Emails added here will receive emails for all ticket creations and updates."
      >
        <kendo-svg-icon [icon]="infoCircleIcon"></kendo-svg-icon>
      </span>
    </h5>
  </div>
</div>

<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-column">
    <label
      class="form-label small text-muted mb-1"
      for="adminorcustomer_organizations_soccommunications_ticketingemails_filter_isprimary"
    >
      Primary
    </label>
    <kendo-dropdownlist
      id="adminorcustomer_organizations_soccommunications_ticketingemails_filter_isprimary"
      [defaultItem]="{ text: 'All', value: null }"
      textField="text"
      valueField="value"
      [data]="isPrimaryOptions"
      [style]="{ width: '200px' }"
      (valueChange)="isPrimaryChange($event)"
    ></kendo-dropdownlist>
  </div>
  <button
    id="adminorcustomer_organizations_soccommunications_ticketingemails_addemail"
    type="button"
    class="cyflare-btn-primary align-self-end"
    (click)="openEditor()"
  >
    Add Email
  </button>
</div>

@if (hasMultiplePrimaries()) {
  <div
    id="adminorcustomer_organizations_soccommunications_ticketingemails_multipleprimaries"
    class="alert alert-warning"
    role="alert"
  >
    This organization has more than one primary ticketing email. Only one is allowed. Use 'Make primary' on the
    one to keep, or unmark the extras.
  </div>
}

@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
    [initialFilters]="initialFilters"
    [successCallback]="onListLoaded"
    (click)="onTableClick($event)"
  ></app-datatable>
}

@if (formGroup(); as form) {
  <kendo-dialog
    [title]="isNew() ? 'Add Email' : 'Edit Email'"
    [width]="520"
    [minWidth]="340"
    (close)="closeEditor()"
  >
    <form [formGroup]="form">
      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soccommunications_ticketingemails_email"
        >
          Email
        </label>
        <input
          id="adminorcustomer_organizations_soccommunications_ticketingemails_email"
          type="email"
          class="form-control"
          formControlName="email"
        />
      </div>

      <!-- Only offered when adding an email to an org without a primary; the
           control is disabled otherwise (see applyPrimaryAvailability). -->
      @if (form.controls.is_primary.enabled) {
        <div class="form-check mb-2">
          <input
            id="adminorcustomer_organizations_soccommunications_ticketingemails_isprimary"
            type="checkbox"
            class="form-check-input"
            formControlName="is_primary"
          />
          <label
            class="form-check-label small"
            for="adminorcustomer_organizations_soccommunications_ticketingemails_isprimary"
          >
            Primary
          </label>
        </div>
      }

      @if (primaryError(); as message) {
        <div
          id="adminorcustomer_organizations_soccommunications_ticketingemails_primaryerror"
          class="text-danger small"
          role="alert"
        >
          {{ message }}
        </div>
      }
    </form>

    <kendo-dialog-actions>
      <button
        id="adminorcustomer_organizations_soccommunications_ticketingemails_discard"
        type="button"
        class="cyflare-btn-secondary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="closeEditor()"
      >
        Discard
      </button>
      <button
        [id]="
          isNew()
            ? 'adminorcustomer_organizations_soccommunications_ticketingemails_add'
            : 'adminorcustomer_organizations_soccommunications_ticketingemails_save'
        "
        type="button"
        class="cyflare-btn-primary cyflare-btn-sm"
        [disabled]="isSaving() || form.invalid || !hasFormChanged()"
        (click)="save()"
      >
        @if (isSaving()) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Saving...
        } @else {
          {{ isNew() ? 'Add' : 'Save' }}
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
